module.exports = {
      id: "alert-usage",
      viewBox: "0 0 44 40",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#alert-usage",
      toString: function () {
        return this.url;
      }
    }